module.exports = __webpack_public_path__ + "img/level_five_lock.22780cad.png";